import Vue from 'vue';
import { defaults } from '../defaults';
/** 如果你是运行在 Vue 的环境下，建议在 import 这个库的同时，import 这个文件 */
defaults.context.immutable = false;
defaults.context.set = Vue.set;
defaults.context.delete = Vue.delete;
